import { get } from '../axios'
import axios from "axios";

// 控制器波形数据-列表
export const waveList = params => get(`/web/collect/wave/list`,params);

// 控制器波形数据-源数据下载
export const waveDownload = params => {
  return axios.get(`/web/collect/wave/download/` + params, {
    responseType: 'stream', 
    headers: {
      'X-Download': 'true' // 添加自定义头部标识文件下载
    }
  });
};
// 控制器波形数据-查看波形
export const waveView = params => get(`/web/collect/wave/view/`+params, '');